import { useClientPortalAPI } from "@certn/api";
import {
  AssignReviewerPicker,
  NotificationEmailsSection,
} from "@certn/client-users";

type RequestorFieldsProps = {
  enableStaleReviewerWarning?: boolean;
};

export function RequestorFields({
  enableStaleReviewerWarning = false,
}: RequestorFieldsProps) {
  const { data, isLoading, error } = useClientPortalAPI(
    "/api/internal/client-portal/users/eligible-reviewers/"
  );

  return (
    <>
      <AssignReviewerPicker
        reviewers={data}
        isLoading={isLoading}
        error={error}
        enableStaleReviewerWarning={enableStaleReviewerWarning}
      />
      <NotificationEmailsSection />
    </>
  );
}
